import {
  SponsoredProductAction,
  SponsoredProductActionType,
  SponsoredProductState,
} from "../types/sponsoredProducts"

const initialState: SponsoredProductState = {
  campaignData: {
    campaigns: [],
    defaultTargetAcos: [],
    limitedCPCValue: {
      conditions: [],
    },
    targetAcos: [],
    getAOVData: {
      customerId: "",
      profileId: "",
      aovs: [],
    },
    TOSPercentage: 0,
    PPPercentage: 0,
    ROSPercentage: 0,
    ABPercentage: 0,
    ADPercentage: 0,
    currentPageNo: 0,
    defaultBid: 0,
    defaultOrder: 0,
    limitValue: 0,
    maxTargetCPC: 0,
    minTargetCPC: 0,
    lastDateWithoutData: "",
    updatedCompanyIdsToday: [],
    excludeAdjustedCampaign: false,
  },
  isLoading: false,
  error: null,
}

export const sponsoredProductSKCReducer = (
  state = initialState,
  action: SponsoredProductAction
): SponsoredProductState => {
  switch (action.type) {
    case SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_SUCCESS:
      return {
        campaignData: action.payload,
        isLoading: false,
        error: null,
      }
    case SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    case SponsoredProductActionType.SET_CAMPAIGN_DATA:
      return {
        ...state,
        campaignData: {
          ...state.campaignData,
          campaigns: action.payload,
        },
      }
    case SponsoredProductActionType.CHANGE_CAMPAIGN:
      return {
        ...state,
        campaignData: {
          ...state.campaignData,
          campaigns: state.campaignData.campaigns.map((campaign) => {
            if (campaign.campaignId === action.payload.campaignId) {
              return action.payload
            }
            return campaign
          }),
        },
      }
    case SponsoredProductActionType.FETCH_CAMPAIGN_STATE_SUCCESS:
      return {
        ...state,
        campaignData: {
          ...state.campaignData,
          campaigns: state.campaignData.campaigns.map((campaign) => {
            const campaignIdWithChangedState = action.payload.find(
              (stateByCampaignId) => stateByCampaignId.campaignId === campaign.campaignId
            )

            if (campaignIdWithChangedState) {
              return {
                ...campaign,
                campaignStatus: campaignIdWithChangedState.state,
              }
            }
            return campaign
          }),
        },
      }
    case SponsoredProductActionType.FETCH_CAMPAIGN_STATE_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}
